import { Pipe, PipeTransform, inject } from "@angular/core";
import { formatDate, TitleCasePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: "relativeTime",
    standalone: true,
    pure: false,
})
export class RelativeTimePipe implements PipeTransform {
    private readonly translateService = inject(TranslateService);
    private readonly titlecasePipe = inject(TitleCasePipe);

    transform(value: Date | string | null | undefined): string {
        if (!value) return "";

        const now = Date.now();
        const created = new Date(value);
        // Ensure UTC comparison: if no timezone info, treat as UTC
        const createdMs = typeof value === "string" && !value.endsWith("Z") && !value.includes("+")
            ? created.getTime() - created.getTimezoneOffset() * 60000
            : created.getTime();
        const diffMs = now - createdMs;
        const diffMin = Math.floor(diffMs / 60000);

        if (diffMin < 1) {
            return this.translateService.instant("QUOTE.DETAIL.COMMENTS.DATE_RECENT");
        }
        if (diffMin === 1) {
            return this.translateService.instant("QUOTE.DETAIL.COMMENTS.DATE_1_MINUTE");
        }
        if (diffMin < 60) {
            return this.translateService.instant("QUOTE.DETAIL.COMMENTS.DATE_MINUTES", { minutes: diffMin });
        }

        const diffHours = Math.floor(diffMin / 60);
        if (diffHours === 1) {
            return this.translateService.instant("QUOTE.DETAIL.COMMENTS.DATE_1_HOUR");
        }
        if (diffHours < 24) {
            return this.translateService.instant("QUOTE.DETAIL.COMMENTS.DATE_HOURS", { hours: diffHours });
        }

        const locale = this.translateService.defaultLang || "en";
        return this.titlecasePipe.transform(formatDate(created, "dd MMM yyyy", locale));
    }
}
